<template>
  <div class="g-content">
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <div class="page-title">
          {{ isEdit ? $t('application_menu_edit') : $t('application_menu_add') }}
        </div>

        <div class="g-content-filter-right">
          <a-button
            type="default"
            @click="$router.push({ name: 'ApplicationList' })"
            icon="double-left"
          >
            {{ $t('com_btn_back') }}
          </a-button>

          <a-button type="primary" @click="handleSubmit">
            {{ $t('com_btn_save') }}
          </a-button>
        </div>
      </div>
    </div>
    <div class="g-content-main common-filter-main">
      <a-form-model
        :model="form"
        :rules="formRules"
        ref="formElement"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 18 }"
        style="width:760px;margin:0 auto;"
      >
        <!-- 应用名称 -->
        <a-form-model-item :label="$t('application_form_name')" prop="name">
          <a-input
            v-model="form.name"
            :placeholder="$t('application_form_name_placeholder')"
            allowClear
            @input="formInput"
          />
        </a-form-model-item>

        <!-- 应用状态 -->
        <a-form-model-item :label="$t('application_form_status')" prop="status">
          <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            v-model="form.status"
            :placeholder="$t('application_form_status_placeholder')"
          >
            <a-select-option :value="0">
              {{ $t('com_form_disabled') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('com_form_enabled') }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 安装日期 -->
        <a-form-model-item :label="$t('application_form_installTime')" prop="installTime">
          <a-date-picker
            v-model="form.installTime"
            :placeholder="$t('application_form_installTime_placeholder')"
          />
        </a-form-model-item>

        <!-- 应用描述 -->
        <a-form-model-item :label="$t('application_form_description')" prop="intro">
          <a-textarea
            v-model="form.intro"
            :placeholder="$t('application_form_description_placeholder')"
            :rows="6"
            allowClear
            @input="formInput"
          />
        </a-form-model-item>

        <!-- 应用图标 -->
        <a-form-model-item :label="$t('application_form_icon')">
          <UploadOSS
            :value="form.icons"
            :manuallyUpload="false"
            @change="
              fileList => {
                form.icons = fileList || [];
              }
            "
            :maxCount="1"
            uploadDirInOSS="images"
            uploadType="image"
            ref="uploadFile"
          />
        </a-form-model-item>

        <!-- appId -->
        <a-form-model-item label="appId" prop="appid">
          <a-input
            v-model="form.appid"
            :placeholder="$t('application_form_app_id_placeholder')"
            allowClear
            @input="formInput"
          />
          <!-- <a-input v-else :default-value="$t('application_form_auto_generation_placeholder')" disabled /> -->
        </a-form-model-item>

        <!-- AppSecret -->
        <!-- <a-form-model-item
          label="appSecret"
          prop="appSecret"
          v-if="isEdit"
        >
          <a-input
            v-if="isEdit"
            v-model="form.appSecret"
            :placeholder="$t('application_form_app_secret_placeholder')"
            allowClear
            @input="formInput"
            disabled
          />
          <a-input
            v-else
            :default-value="$t('application_form_auto_generation_placeholder')"
            disabled
          />
        </a-form-model-item> -->

        <!-- 绑定用户 -->
        <a-form-model-item :label="$t('application_form_bind_username')" prop="bindUserId">
          <a-select
            v-model="form.bindUserId"
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            :placeholder="$t('application_form_bind_username_placeholder')"
            allowClear
            :filter-option="filterOption"
            show-search
          >
            <a-select-option :value="user.userId" v-for="user in userList" :key="user.userId">
              {{ user.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <!-- 错误描述 -->
      <div class="form-error-text">
        <Icon type="error" v-if="formError" />
        <p>{{ formError }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/application';
import { UserList } from '@/api/system/user';
import moment from 'moment';

export default {
  data() {
    return {
      form: {
        // 应用名称
        name: '',
        // 应用简介
        intro: '',
        // 应用图标地址,可多个地址,前端赋值如:icons: ['xxx', 'xxx', 'xxx'],如果没变化则可以不传或null,如果删除则传递空数组
        icons: [],
        // 应用状态，0：禁用; 1：启用/使用;
        status: 1,
        // 绑定用户主键
        bindUserId: undefined,
        // 安装日期
        installTime: undefined,
        appid: '',
      },

      // 用户搜索
      userKeyword: '',

      // 表单
      formRules: {
        name: [
          {
            required: true,
            message: this.$t('application_form_name_placeholder'),
          },
        ],
        status: [
          {
            required: true,
            message: this.$t('application_form_status_placeholder'),
          },
        ],

        installTime: [
          {
            required: true,
            message: this.$t('application_form_installTime_placeholder'),
          },
        ],
        intro: [
          {
            required: true,
            message: this.$t('application_form_description_placeholder'),
          },
        ],
        appid: [
          {
            required: true,
            message: this.$t('application_form_app_id_placeholder'),
          },
        ],
        bindUserId: [
          {
            required: true,
            message: this.$t('application_form_bind_username_placeholder'),
          },
        ],
      },
      formError: '',

      // 客户列表
      userListAll: [],
      userList: [],

      info: {},
      // 编辑时的id
      id: null,

      // 是否为编辑
      isEdit: false,
    };
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.isEdit = true;
      this.id = this.$route.params.id;
    }

    // 先获取form需要的数据
    this.getFormData();
  },
  methods: {
    // 先获取表单数据
    getFormData() {
      const apiList = [
        // 获取所有客户
        this.getUserList(),
      ];

      // 是否为编辑
      if (this.isEdit) {
        apiList.push(this.getAppInfo());
      }

      Promise.all(apiList).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
      });
    },

    // 获取用户列表
    getUserList() {
      const params = {
        pageNo: 1,
        pageSize: 10000,
      };
      return UserList(params).then(res => {
        if (res.code === 0) {
          this.userListAll = res.data || [];
          this.userList = res.data || [];
        }
      });
    },

    // 搜索用户(前端匹配)
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // 编辑
    getAppInfo() {
      let id;
      if (this.$route && this.$route.params && this.$route.params.id) {
        id = this.$route.params.id;
      }
      if (!id) {
        return;
      }

      return API.AppDetail({ id: id }).then(res => {
        if (res.code === 0) {
          this.info = res.data || {};

          for (let key in this.form) {
            if (key === 'installTime') {
              this.form[key] = moment(this.info[key]);
            } else if (key === 'bindUserId') {
              this.form[key] = this.info['bindBy'];
            } else {
              this.form[key] = this.info[key];
            }
          }
        }
      });
    },

    // 提交
    handleSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.$confirm({
            title: this.$t('user_confirm_save_title'),
            centered: true,
            onOk: () => {
              this.postData();
            },
          });
        }
      });
    },

    // 提交数据
    postData() {
      const params = {
        ...this.form,
      };

      if (this.form.installTime) {
        params.installTime = new Date(this.form.installTime).getTime();
      }

      if (this.isEdit) {
        params.id = Number(this.id);

        this.$store.commit('setFreeze', this.$t('com_ongoing_update'));
        API.AppEdit(params)
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t('com_msg_edit_success'));
              this.$router.replace({ name: 'ApplicationList' });
            } else {
              this.formError = res.message;
            }
          })
          .finally(() => {
            this.$store.commit('setFreeze', false);
          });
      } else {
        this.$store.commit('setFreeze', this.$t('com_ongoing_save'));

        API.AppAdd(params)
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t('com_msg_save_success'));

              this.$router.replace({ name: 'ApplicationList' });
            } else {
              this.formError = res.message;
            }
          })
          .finally(() => {
            this.$store.commit('setFreeze', false);
          });
      }
    },

    // error reset
    formInput() {
      this.formError = '';
    },
  },
};
</script>
<style lang="less" scoped>
.page-title {
  align-items: center;
  color: #18181a;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.form-error-text {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #f00;
  width: 100%;
  text-align: center;
  font-size: 14px;

  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}
</style>
